<section class="billing-settings">
  <mat-card class="billing-settings-card">
    <h2>{{ data.header }}</h2>
    @for (setting of billingSettings; track setting) {
      <div class="setting auto-pay">
        <i
          role="img"
          [attr.aria-label]="setting.icon === 'check' ? 'Complete' : 'Not complete'"
          class="fa-thin fa-circle-{{ setting.icon }} fa-4x"
        ></i>
        <div class="setting-details">
          <h3>{{ setting.header }}</h3>
          <a [routerLink]="setting.linkUrl">{{ setting.linkText }}</a>
        </div>
      </div>
    }
  </mat-card>
</section>
